import MockAdapter from 'axios-mock-adapter';
import registerAuthMocks from './handlers/auth.mock';
import registerGroupMocks from './handlers/groups.mock';
import registerGroupMessageMocks from './handlers/groupMessages.mock';
import registerProfileMocks from './handlers/profiles.mock';
import registerEventMocks from './handlers/events.mock';
import registerPaymentMocks from './handlers/payments.mock';
import registerFeedMocks from './handlers/feed.mock';
import registerMediaMocks from './handlers/media.mock';
import registerNotificationMocks from './handlers/notifications.mock';
import registerVideoMocks from './handlers/video.mock';
import registerSuperAdminMocks from './handlers/superAdmin.mock';

const HANDLERS = [
  registerAuthMocks,
  registerGroupMocks,
  registerGroupMessageMocks,
  registerProfileMocks,
  registerEventMocks,
  registerPaymentMocks,
  registerFeedMocks,
  registerMediaMocks,
  registerNotificationMocks,
  registerVideoMocks,
  registerSuperAdminMocks,
];

export function attachMocks(axiosInstance) {
  // onNoMatch: 'throwException' makes any endpoint we forgot to mock fail loudly during a
  // demo build instead of silently falling through to a real (nonexistent) backend at the
  // placeholder demo baseURL.
  const mock = new MockAdapter(axiosInstance, { delayResponse: 250, onNoMatch: 'throwException' });

  HANDLERS.forEach((register) => register(mock));

  return axiosInstance;
}
